export * from './prevenda-gerar-saida-estoque.component';